import {
  SocialAccount,
  Merchant,
  OpeningTimes,
  File,
  Contact,
  Address,
  OpeningTimesGroup,
} from './index';

export interface Location {
  _id?: string;
  nanoid?: string;
  merchant?: string | Merchant;
  name?: string;
  description?: string;
  address?: Address;
  active?: boolean;
  approved?: boolean;
  socials?: SocialAccount[];
  tags?: string[];
  contact?: Contact;
  defaultOpeningTimesName?: string;
  openingTimes?: OpeningTimes; //Default/GMT
  altOpeningTimes?: OpeningTimes; //BST
  openingTimesGroups?: OpeningTimesGroup[];
  cover?: File;
  logo?: File;
  qrCode?: File;
  formattedAddress?: string;
}
